import React from "react";
import { Routes, Route } from "react-router-dom";
import ListContactUs from "../Components/Contact Us/listContactUs";

const ContactUsRoutes = () => {
  return (
    <Routes>
      <Route
        path="/contact_us"
        element={<ListContactUs />}
      />
    </Routes>
  );
};

export default ContactUsRoutes;